export const formatGs = (n) =>
  `₲ ${Number(n || 0).toLocaleString("es-PY", { maximumFractionDigits: 0 })}`;
